import { ItemName, Locale } from '@ps-smart-cp/ppfw-client';

const names = {
  operationControl: ItemName.of([Locale.ja, '運用制御'], [Locale.en, 'Operation Control']),
  operationStart: ItemName.of([Locale.ja, '運用開始'], [Locale.en, 'Start Operation']),
  operationCancel: ItemName.of([Locale.ja, '運用取消'], [Locale.en, 'Cancel Operation']),
  checkOperationStart: ItemName.of(
    [Locale.ja, '各種設定および移行データの検証を完了したら、運用を開始できます。'],
    [
      Locale.en,
      'You can start operation after completing various settings and verification of the balance data migrated.',
    ],
  ),
  functionExecutionAuthorityError: ItemName.of([Locale.ja, '機能実行権限エラー']),
  sandboxEnvironmentError: ItemName.of([Locale.ja, '【エラー】この機能はSandBox環境では使用できません。']),
  beforeOperationStartError: ItemName.of([
    Locale.ja,
    '【エラー】運用状態が運用開始前です。機能を実行できません。(ECO13031)',
  ]),
  afterOperationStartError: ItemName.of([
    Locale.ja,
    '【エラー】運用状態が運用開始後です。機能を実行できません。(ECO13031)',
  ]),
};

export const operationControl = {
  names,
};
